import React from 'react';
import styles from './GoogleMapButton.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";

function GoogleMapButton({ facilityPref, facilityAddress, facilityName }) {
  // ウェブサイトの基本URL（例: 施設一覧ページのURL）
  const baseUrl = "https://maps.google.com/maps?q=";

  // 住所と施設名をエンコードして完全なURLを生成
  const shareUrl = `${baseUrl}${facilityPref}${encodeURIComponent(facilityAddress)}+${encodeURIComponent(facilityName)}&hl=ja`;

  return (
    <a className={styles.LinkMapButton} href={shareUrl} target='gmap'><FontAwesomeIcon icon={faExternalLink} /> Google Map</a>
  );
}

export default GoogleMapButton;
